import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, StarIcon } from 'lucide-react';
const testimonials = [['VT', 'V.T.', 'ESL Teacher | New York, USA', 'The A2 volume completely changed how my students experience progress. The lessons are already structured — I just deliver them.'], ['CR', 'C.R.', 'ESL Instructor | Melbourne, Australia', 'The emergency lessons saved me more times than I can count. Now I just open the backup library and teach.'], ['DG', 'D.G.', 'ESL Teacher | Toronto, Canada', 'I review the grammar guide before every session and walk in knowing exactly what I am going to explain.'], ['AM', 'A.M.', 'ESL Instructor | London, United Kingdom', 'The mixed-level guide gave me back confidence with multi-level groups. The right adaptation is ready before class starts.'], ['SR', 'S.R.', 'ESL Teacher | Dublin, Ireland', 'The speaking activity bank was a complete revelation. Students feel like they are having real conversations, not exercises.']];
export function ExtendedTestimonials() {
  return <section className="bg-white px-4 py-20 sm:py-28" data-id="element-14">
      <div className="mx-auto max-w-6xl" data-id="element-15">
        <div className="mx-auto max-w-3xl text-center" data-id="element-16">
          <div className="section-rule mx-auto" data-id="element-17" />
          <p className="mt-5 text-xs font-extrabold tracking-[.16em] text-gold-500" data-id="element-18">
            TRUSTED BY ESL TEACHERS WORLDWIDE
          </p>
          <h2 className="mt-4 font-display text-3xl uppercase leading-tight text-navy-950 sm:text-5xl" data-id="element-19">
            Teachers feel the <span className="text-gold-500" data-id="element-20">difference.</span>
          </h2>
        </div>
        <div className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-21">
          {testimonials.map(([initials, name, role, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.07
        }} className={`relative flex flex-col rounded-2xl border border-[#e6d9b7] bg-ivory p-7 ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-22">
              <QuoteIcon size={44} className="absolute right-5 top-5 text-gold-300/35" data-id="element-23" />
              <div className="mb-5 flex gap-1 text-gold-500" data-id="element-24">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} size={15} fill="currentColor" data-id="element-25" />)}
              </div>
              <p className="relative z-10 flex-1 text-sm leading-6 text-slate-600 italic" data-id="element-26">
                “{quote}”
              </p>
              <div className="mt-7 flex items-center gap-3" data-id="element-27">
                <span className="grid h-11 w-11 place-items-center rounded-full bg-navy-900 text-sm font-extrabold text-gold-300" data-id="element-28">
                  {initials}
                </span>
                <div data-id="element-29">
                  <p className="text-sm font-extrabold text-navy-950" data-id="element-30">{name}</p>
                  <p className="text-xs font-semibold text-navy-700" data-id="element-31">{role}</p>
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}